
import { defineComponent } from 'vue';

import AdListItem from '@/ad/mixins/AdListItem';
import AdListGallery from './AdListGallery.vue';
import SexIcon from '@/shared/components/SexIcon.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import ReadMore from '@/shared/components/ReadMore.vue';
import { adService } from '../AdService';
import store from '@/store';

export default defineComponent({
  mixins: [AdListItem],
  emits: ['removed'],
  components: {
    AdListGallery,
    SexIcon,
    ResizableImage,
    ReadMore,
  },
  computed: {
    landArea(): string {
      if (this.ad && (this.ad.estateType === 200 || this.ad.estateType === 300)) {
        return (this.ad.landArea / 100).toLocaleString();
      } else {
        return '';
      }
    },
    classByAdType(): string {
      if (this.ad) {
        switch (this.ad.adType) {
          case 1:
            return 'is-sale';
          case 2:
            return 'is-rent';
          case 3:
            return 'is-roommates';
        }
      }
      return '';
    },
  },
  methods: {
    async remove() {
      if (!this.ad) return;
      const result = await adService.removeCompare(this.ad.adId);
      if (result.status === 200) {
        store.dispatch('compareCount', result.data.count);
        this.$emit('removed');
      }
    },
  },
});
